import { baseApi } from "./baseApi";

// OrderItemTypes API
export const orderItemTypesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrderItemTypes: builder.query({
      query: (params) => {
        let url = "order_item_types";

        url += "?";

        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.name) {
          url += `name=${params.name}&`;
        }
        if (params.code) {
          url += `code=${params.code}&`;
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    })
  })
});

// Export mutations and queries
export const { useGetOrderItemTypesQuery } = orderItemTypesApi;
